import iso6391 from "iso-639-1";

export const genders = [
    { label: 'All', value: 'all' },
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
  ];

 export const budgets = [
    { label: 'Daily Budget', value: 'daily budget' },
    { label: 'Lifetime Budget', value: 'lifetime budget' },
  ];

 export const languages = [
    { code: '', name: 'All Languages' },
    ...iso6391.getAllCodes().map((code) => ({
      code: code,
      name: iso6391.getName(code),
    })),
  ];